import styled from 'styled-components';

const CustomCursorWrapper = styled.div`
  height: 100%;
  width: 100%;
  cursor: ${(props) => (props.cursorUrl ? `url('${props.cursorUrl}'), auto` : 'auto')};
`;

export default CustomCursorWrapper;
